import { ChartOptions } from 'chart.js';

export const getStackedBarOptions = (isMobile: boolean): ChartOptions<'bar'> => {
  return {
    indexAxis: 'x' as const,
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1.5,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        align: 'center',
        position: 'top',
        labels: {
          pointStyle: 'circle',
          usePointStyle: true,
          padding: 10,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          font: {
            size: isMobile ? 10 : 12,
            weight: 'bold',
          },
          color: '#374151',
        },
        grid: {
          color: '#e5e7eb',
          lineWidth: 1,
        },
      },
      y: {
        ticks: {
          font: {
            size: isMobile ? 10 : 12,
            weight: 'bold',
          },
          color: '#374151',
        },
        grid: {
          display: false,
        },
      },
    },
    interaction: {
      mode: 'index' as const,
      intersect: false,
    },
  };
};
